import React from 'react';
import { Card } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import './Author.css';
var defaultProps = {};
export default function Author(_ref) {
  var author = _ref.author;
  if (_isEmpty(author)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Card.Description, {
    className: "author"
  }, author);
}
Author.defaultProps = defaultProps;